import isObject from "lodash/isObject";

export default {
  isInitial: (state) => {
    return state.isInitial;
  },

  playbackSettings: (state) => {
    return state.playbackSettings;
  },

  isActiveDateInputDialog: (state) => {
    return state.isActiveDateInputDialog;
  },

  playbackBaseTime: (state) => {
    return state.playbackSettings.baseTime;
  },

  playbackStartTime: (state) => {
    return state.playbackSettings.startTime;
  },

  playbackEndTime: (state) => {
    return state.playbackSettings.endTime;
  },

  playbackTimeNow: (state) => {
    return state.playbackSettings.now;
  },

  playbackSecondsPerFrame: (state) => {
    return state.playbackSettings.secondsPerFrame;
  },

  playbackStatus: (state) => {
    return state.playbackSettings.playbackStatus;
  },

  layerFilters: (state) => {
    return state.layerFilters;
  },

  hasRgPlaybackObjects({ rgPlaybackObjects }) {
    if (!Array.isArray(rgPlaybackObjects)) return false;
    return rgPlaybackObjects.length > 0;
  },

  visibleTracks: state => {
    return state.visibleTracks;
  },

  visibleTrackVessels: ({ visibleTracks }) => {
    if (!isObject(visibleTracks)) return [];
    if (!Array.isArray(visibleTracks.vessels)) return [];
    return visibleTracks.vessels;
  },

  isVisibleTrack: (state) => (type, id) => {
    const found = state.visibleTracks.vessels.find((el) => el === id);

    return typeof found !== "undefined";
  },
};
